import LinkButton from '@core/components/linkbutton/LinkButton';
import classes from './EmptyPage.module.scss';

import EmptyState from 'assets/icons/note-remove.svg?url';

const EmptyPage = () => {
	return (
		<section className={`${classes['empty']}`}>
			<img src={EmptyState} alt="empty-resualt" />
			<h3>You have no completed or in-progress course</h3>
			<p>
				Haven’t found the course you’re looking for yet? Explore courses here.
			</p>
			<LinkButton to="/explore?featured_contents=true&content=lecture" kind="primary-color">
				Explore courses
			</LinkButton>
		</section>
	);
};

export default EmptyPage;
